import { render, staticRenderFns } from "./ViewJds.vue?vue&type=template&id=3dbddf75&scoped=true&"
import script from "./ViewJds.vue?vue&type=script&lang=js&"
export * from "./ViewJds.vue?vue&type=script&lang=js&"
import style0 from "./ViewJds.vue?vue&type=style&index=0&id=3dbddf75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbddf75",
  null
  
)

export default component.exports